import React from 'react';
import { Link } from 'react-router-dom';
import sun from "../assets/sun.png";

const Footer = () => {
    const token = localStorage.getItem("token") || localStorage.getItem("jwt") || "";

    const guestLinks = [
        { label: "Home", to: "/" },
        { label: "About Us", to: "/about" },
        { label: "Business", to: "/bussiness" },
        { label: "Products", to: "/products" },
        { label: "Contact Us", to: "/contact" },
    ];

    const privateLinks = [
        { label: "Dashboard", to: "/dashboard" },
        { label: "My Profile", to: "/Myprofile" },
        { label: "Products", to: "/products" },
        { label: "Wallet", to: "/wallet" },
        { label: "Orders", to: "/Order" },
        { label: "Tree View", to: "/Tree" },
        { label: "Withdraw", to: "/WalletWithdraw" },
    ];

    const links = token ? privateLinks : guestLinks;

    return (
        <footer className="main-footer" style={{
            backgroundColor: '#006600',
            color: '#ffffff',
            padding: '40px 0 20px',
            marginTop: 'auto',
            /* Base padding-bottom will be overridden by CSS on mobile if needed */
        }}>
            <style>{`
                @media (max-width: 900px) {
                    .main-footer {
                        padding-bottom: 90px !important;
                    }
                }
            `}</style>
            <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', padding: '0 20px' }}>

                {/* About Section */}
                <div style={{ flex: '1', minWidth: '250px', marginBottom: '20px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '15px' }}>
                        <img src={sun} alt="Sun logo" style={{ height: '40px', width: 'auto' }} />
                        <h4 style={{ color: '#f39c12', margin: 0 }}>SUN Distributors Pvt. Ltd.</h4>
                    </div>
                    <p style={{ fontSize: '14px', lineHeight: '1.6', color: '#ffffff' }}>
                        We provide the best products and services for our customers. Your satisfaction is our top priority.
                    </p>
                    <div style={{ display: 'flex', gap: '15px', marginTop: '20px' }}>
                        <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" style={{ color: '#ffffff', transition: 'transform 0.3s' }}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" /></svg>
                        </a>
                        <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" style={{ color: '#ffffff', transition: 'transform 0.3s' }}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5" /><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" /><line x1="17.5" y1="6.5" x2="17.51" y2="6.5" /></svg>
                        </a>
                        <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" style={{ color: '#ffffff', transition: 'transform 0.3s' }}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58 2.78 2.78 0 0 0 1.95 1.96C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.96-1.96A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z" /><polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" /></svg>
                        </a>
                    </div>
                </div>

                {/* Quick Links */}
                <div style={{ flex: '1', minWidth: '250px', marginBottom: '20px' }}>
                    <h4 style={{ color: '#f39c12', marginBottom: '15px' }}>Quick Links</h4>
                    <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
                        {links.map((link, index) => (
                            <li key={index} style={{ marginBottom: '10px' }}>
                                <Link to={link.to} style={{ color: '#ffffff', textDecoration: 'none', transition: 'color 0.3s', fontWeight: 'bold' }}>
                                    {link.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Contact Info */}
                <div style={{ flex: '1', minWidth: '250px', marginBottom: '20px' }}>
                    <h4 style={{ color: '#f39c12', marginBottom: '15px' }}>Contact Info</h4>
                    <p style={{ fontSize: '14px', color: '#ffffff', marginBottom: '10px' }}>
                        <strong>Email:</strong> info@mysun.in
                    </p>
                    <p style={{ fontSize: '14px', color: '#ffffff', marginBottom: '10px' }}>
                        <strong>Phone:</strong> +91 9182729720
                    </p>
                    <p style={{ fontSize: '14px', color: '#ffffff' }}>
                        <strong>Address:</strong> <a href="https://www.google.com/maps/search/?api=1&query=Sun+Entrepreneurs+Lawson's+Bay+Colony+Pedda+Waltair+Visakhapatnam+530017" target="_blank" rel="noopener noreferrer" style={{ color: "inherit", textDecoration: "none", display: 'inline-flex', alignItems: 'center', gap: '5px' }}>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
                                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                                <circle cx="12" cy="10" r="3" />
                            </svg>
                            F. NO 101, 48-13-17, Sringar, Janakirama street, Near RTC Complex, Visakhapatnam-16
                        </a>
                    </p>
                </div>

            </div>

            {/* Copyright */}
            <div
                style={{
                    textAlign: "center",
                    marginTop: "20px",
                    paddingTop: "20px",
                    borderTop: "1px solid rgba(255,255,255,0.2)",
                    fontSize: "14px",
                    color: "white",
                }}
            >
                © {new Date().getFullYear()} SUN Distributors Pvt. Ltd. All rights reserved. <br />

            </div>
        </footer>
    );
};

export default Footer;

